import { IGameEquip } from "../type"
import json from "./json/boss.json"
import equipJson from "@project/data/rogue_4/game/equip.json"
import EQUIP_IMAGE01 from "@rogue_4/assets/img/game/equip/01.png"
import EQUIP_IMAGE02 from "@rogue_4/assets/img/game/equip/02.png"
import EQUIP_IMAGE03 from "@rogue_4/assets/img/game/equip/03.png"
import EQUIP_IMAGE04 from "@rogue_4/assets/img/game/equip/04.png"
import EQUIP_IMAGE05 from "@rogue_4/assets/img/game/equip/05.png"
import EQUIP_IMAGE06 from "@rogue_4/assets/img/game/equip/06.png"
import EQUIP_IMAGE07 from "@rogue_4/assets/img/game/equip/07.png"
import EQUIP_IMAGE08 from "@rogue_4/assets/img/game/equip/08.png"
import EQUIP_IMAGE09 from "@rogue_4/assets/img/game/equip/09.png"
import EQUIP_IMAGE10 from "@rogue_4/assets/img/game/equip/10.png"
import EQUIP_IMAGE11 from "@rogue_4/assets/img/game/equip/11.png"
import EQUIP_IMAGE12 from "@rogue_4/assets/img/game/equip/12.png"
import EQUIP_IMAGE13 from "@rogue_4/assets/img/game/equip/13.png"
import EQUIP_IMAGE14 from "@rogue_4/assets/img/game/equip/14.png"
import EQUIP_IMAGE15 from "@rogue_4/assets/img/game/equip/15.png"
import EQUIP_IMAGE16 from "@rogue_4/assets/img/game/equip/16.png"
import EQUIP_IMAGE17 from "@rogue_4/assets/img/game/equip/17.png"
import EQUIP_IMAGE18 from "@rogue_4/assets/img/game/equip/18.png"
import EQUIP_IMAGE19 from "@rogue_4/assets/img/game/equip/19.png"
import EQUIP_IMAGE20 from "@rogue_4/assets/img/game/equip/20.png"
import EQUIP_IMAGE21 from "@rogue_4/assets/img/game/equip/21.png"
import EQUIP_IMAGE22 from "@rogue_4/assets/img/game/equip/22.png"
import EQUIP_IMAGE23 from "@rogue_4/assets/img/game/equip/23.png"
import EQUIP_IMAGE24 from "@rogue_4/assets/img/game/equip/24.png"
import EQUIP_IMAGE25 from "@rogue_4/assets/img/game/equip/25.png"
import EQUIP_IMAGE26 from "@rogue_4/assets/img/game/equip/26.png"
import EQUIP_IMAGE27 from "@rogue_4/assets/img/game/equip/27.png"
import EQUIP_IMAGE28 from "@rogue_4/assets/img/game/equip/28.png"
import EQUIP_IMAGE29 from "@rogue_4/assets/img/game/equip/29.png"
import EQUIP_IMAGE30 from "@rogue_4/assets/img/game/equip/30.png"
import EQUIP_IMAGE31 from "@rogue_4/assets/img/game/equip/31.png"
import EQUIP_IMAGE32 from "@rogue_4/assets/img/game/equip/32.png"
import EQUIP_IMAGE33 from "@rogue_4/assets/img/game/equip/33.png"
import EQUIP_IMAGE34 from "@rogue_4/assets/img/game/equip/34.png"
import EQUIP_IMAGE35 from "@rogue_4/assets/img/game/equip/35.png"
import EQUIP_IMAGE36 from "@rogue_4/assets/img/game/equip/36.png"
import EQUIP_IMAGE37 from "@rogue_4/assets/img/game/equip/37.png"
import EQUIP_IMAGE38 from "@rogue_4/assets/img/game/equip/38.png"
import i18nData from "@rogue_4/locales/zh-CN.json"
import { i18n } from "@/utils/i18n"
import { create } from "zustand"
import specialJson from "./json/special.json"
export const SPECIAL_PERFORMANCE = specialJson["03"]
export const WIN_PERFORMANCE = specialJson["01"]
export const FAIL_PERFORMANCE = specialJson["02"]
export const KILL_PERFORMANCE = specialJson["04"]

const BUFF_BASE_DAMAGE = 2

interface INymphActionBase {
    attack: number
    attackAll: number
    guard: number
    heal: number
    flags: Record<string, boolean>
    buff?: boolean
    double?: boolean
    again?: boolean
    special?: boolean
}

interface IKaltsActionBase {
    attack: number
    guard: number
    heal: number
    flags?: Record<string, boolean>
}

export interface IPerformance {
    text: string
    animation?: {
        kalts?: string
        nymph?: string
    }
}

export interface IKaltsAction {
    key: string
    performance: IPerformance[]
    isHeal: boolean
    base: IKaltsActionBase
}

export interface IGameEquipWithAction extends IGameEquip {
    base: INymphActionBase
    performance: IPerformance[]
    battleDescription: string
}

export interface IActionResult {
    damage: number
    shield: number
    heal: number
    buff?: boolean
    taunted?: boolean
    special?: boolean
    double?: boolean
    flags: Partial<{
        nymphAttackDisabled: boolean
        nymphHealGuardDisabled: boolean
        kaltsAttackDisabled: boolean
        kaltsHealDisabled: boolean
        kaltsTaunt: boolean
    }>
    disabled: { attack?: boolean; guard?: boolean; heal?: boolean }
}

export const KALTS_ACTION_DICT = json as Record<string, IKaltsAction>
export const GAME_EQUIP_DICT: Record<string, IGameEquipWithAction> = {
    "01": { ...equipJson["01"], image: EQUIP_IMAGE01 },
    "02": { ...equipJson["02"], image: EQUIP_IMAGE02 },
    "03": { ...equipJson["03"], image: EQUIP_IMAGE03 },
    "04": { ...equipJson["04"], image: EQUIP_IMAGE04 },
    "05": { ...equipJson["05"], image: EQUIP_IMAGE05 },
    "06": { ...equipJson["06"], image: EQUIP_IMAGE06 },
    "07": { ...equipJson["07"], image: EQUIP_IMAGE07 },
    "08": { ...equipJson["08"], image: EQUIP_IMAGE08 },
    "09": { ...equipJson["09"], image: EQUIP_IMAGE09 },
    "10": { ...equipJson["10"], image: EQUIP_IMAGE10 },
    "11": { ...equipJson["11"], image: EQUIP_IMAGE11 },
    "12": { ...equipJson["12"], image: EQUIP_IMAGE12 },
    "13": { ...equipJson["13"], image: EQUIP_IMAGE13 },
    "14": { ...equipJson["14"], image: EQUIP_IMAGE14 },
    "15": { ...equipJson["15"], image: EQUIP_IMAGE15 },
    "16": { ...equipJson["16"], image: EQUIP_IMAGE16 },
    "17": { ...equipJson["17"], image: EQUIP_IMAGE17 },
    "18": { ...equipJson["18"], image: EQUIP_IMAGE18 },
    "19": { ...equipJson["19"], image: EQUIP_IMAGE19 },
    "20": { ...equipJson["20"], image: EQUIP_IMAGE20 },
    "21": { ...equipJson["21"], image: EQUIP_IMAGE21 },
    "22": { ...equipJson["22"], image: EQUIP_IMAGE22 },
    "23": { ...equipJson["23"], image: EQUIP_IMAGE23 },
    "24": { ...equipJson["24"], image: EQUIP_IMAGE24 },
    "25": { ...equipJson["25"], image: EQUIP_IMAGE25 },
    "26": { ...equipJson["26"], image: EQUIP_IMAGE26 },
    "27": { ...equipJson["27"], image: EQUIP_IMAGE27 },
    "28": { ...equipJson["28"], image: EQUIP_IMAGE28 },
    "29": { ...equipJson["29"], image: EQUIP_IMAGE29 },
    "30": { ...equipJson["30"], image: EQUIP_IMAGE30 },
    "31": { ...equipJson["31"], image: EQUIP_IMAGE31 },
    "32": { ...equipJson["32"], image: EQUIP_IMAGE32 },
    "33": { ...equipJson["33"], image: EQUIP_IMAGE33 },
    "34": { ...equipJson["34"], image: EQUIP_IMAGE34 },
    "35": { ...equipJson["35"], image: EQUIP_IMAGE35 },
    "36": { ...equipJson["36"], image: EQUIP_IMAGE36 },
    "37": { ...equipJson["37"], image: EQUIP_IMAGE37 },
    "38": { ...equipJson["38"], image: EQUIP_IMAGE38 },
}

export const getNymphSummaryText = (result: IActionResult) => {
    let ret = ""
    if (result.taunted) {
        ret =
            ret +
            i18n(i18nData, "rogue_4.game.dialogBoss.battle.taunted") +
            "\n"
    }
    if (result.disabled.attack) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.nymph.attackCancelled"
            ) +
            "\n"
    }
    if (result.damage) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.kalts.damaged"
            ).replace("$0", `${result.damage}`) +
            "\n"
    }
    if (result.buff) {
        ret =
            ret + i18n(i18nData, "rogue_4.game.dialogBoss.battle.debuff") + "\n"
    }
    if (result.disabled.heal) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.nymph.healCancelled"
            ) +
            "\n"
    }
    if (result.heal) {
        ret =
            ret +
            i18n(i18nData, "rogue_4.game.dialogBoss.battle.nymph.heal").replace(
                "$0",
                `${result.heal}`
            ) +
            "\n"
    }
    if (result.disabled.guard) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.nymph.guardCancelled"
            ) +
            "\n"
    }
    if (result.shield) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.nymph.shield"
            ).replace("$0", `${result.shield}`) +
            "\n"
    }
    if (result.flags.kaltsAttackDisabled) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.kalts.attackDisabled"
            ) +
            "\n"
    }
    if (result.flags.kaltsHealDisabled) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.kalts.healDisabled"
            ) +
            "\n"
    }
    if (result.double) {
        ret =
            ret +
            i18n(i18nData, "rogue_4.game.dialogBoss.battle.nymph.double") +
            "\n"
    }
    if (!ret) {
        ret = i18n(i18nData, "rogue_4.game.dialogBoss.battle.nothing")
    }
    return ret.trimEnd()
}

export const getKaltsSummaryText = (result: IActionResult) => {
    let ret = ""
    if (result.disabled.attack) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.kalts.attackCancelled"
            ) +
            "\n"
    }
    if (result.damage) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.nymph.damaged"
            ).replace("$0", `${result.damage}`) +
            "\n"
    }
    if (result.disabled.heal) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.kalts.healCancelled"
            ) +
            "\n"
    }
    if (result.heal) {
        ret =
            ret +
            i18n(i18nData, "rogue_4.game.dialogBoss.battle.kalts.heal").replace(
                "$0",
                `${result.heal}`
            ) +
            "\n"
    }
    if (result.disabled.guard) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.kalts.guardCancelled"
            ) +
            "\n"
    }
    if (result.shield) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.kalts.shield"
            ).replace("$0", `${result.shield}`) +
            "\n"
    }
    if (result.flags.kaltsTaunt) {
        ret =
            ret + i18n(i18nData, "rogue_4.game.dialogBoss.battle.kalts.taunted")
    }
    if (result.flags.nymphAttackDisabled) {
        ret =
            ret +
            i18n(
                i18nData,
                "rogue_4.game.dialogBoss.battle.nymph.attackDisabled"
            )
    }
    if (result.flags.nymphHealGuardDisabled) {
        ret =
            ret +
            i18n(i18nData, "rogue_4.game.dialogBoss.battle.nymph.healDisabled")
    }
    if (!ret) {
        ret = i18n(i18nData, "rogue_4.game.dialogBoss.battle.nothing")
    }

    return ret.trimEnd()
}

export const getKaltsCheckBuffText = (damage: number) => {
    return i18n(
        i18nData,
        "rogue_4.game.dialogBoss.battle.kalts.debuffDamaged"
    ).replace("$0", `${damage}`)
}

export const rollKaltsAction = (ultra: boolean, noHeal: boolean) => {
    // return KALTS_ACTION_DICT["05"]
    if (ultra) return KALTS_ACTION_DICT["ultra"]
    const actions = Object.values(KALTS_ACTION_DICT).filter(
        (a) => (!noHeal || !a.isHeal) && a.key !== "ultra"
    )
    const r = Math.floor(Math.random() * actions.length)
    return actions[r % actions.length]
}

const calcDamageHealth = (health: number, shield: number, damage: number) => ({
    health: shield > damage ? health : Math.max(0, health - damage + shield),
    shield: shield > damage ? shield - damage : 0,
})

const calcHealHealth = (
    health: number,
    shield: number,
    heal: number,
    newShield: number
) => ({
    health: Math.min(10, health + heal),
    shield: Math.min(12, shield + newShield),
})

export interface IGameBattleStore {
    flags: {
        nymphAttackDisabled: boolean
        nymphHealGuardDisabled: boolean
        kaltsAttackDisabled: boolean
        kaltsHealDisabled: boolean
        kaltsTaunt: boolean
    }
    kaltsDebuff: number
    nymphRate: number
    lastBase: INymphActionBase

    kaltsHealth: number
    kaltsShield: number
    nymphHealth: number
    nymphShield: number

    goNymph: (base: INymphActionBase) => IActionResult
    goKalts: (base: IKaltsActionBase) => IActionResult
    checkKaltsBuff: () => number
    restart: () => void
}

const INIT_GAME_BATTLE_STORE = {
    flags: {
        nymphAttackDisabled: false,
        nymphHealGuardDisabled: false,
        kaltsAttackDisabled: false,
        kaltsHealDisabled: false,
        kaltsTaunt: false,
    },
    kaltsDebuff: 0,
    nymphRate: 1,
    lastBase: {
        attack: 0,
        attackAll: 0,
        guard: 0,
        heal: 0,
        flags: {},
        buff: false,
        double: false,
    },

    kaltsHealth: 10,
    kaltsShield: 0,
    nymphHealth: 10,
    nymphShield: 0,
}

export const useGameBattleStore = create<IGameBattleStore>((set, get) => ({
    ...INIT_GAME_BATTLE_STORE,
    goNymph: (base: INymphActionBase) => {
        const {
            lastBase,
            flags: oldFlags,
            nymphRate,
            kaltsHealth,
            kaltsShield,
            nymphHealth,
            nymphShield,
        } = get()
        const {
            attack,
            guard,
            heal,
            attackAll,
            buff,
            double,
            flags: newFlags,
            special,
        } = base.again ? lastBase : base
        // if (!base.again) {
        //     set({ lastBase: base })
        // }
        // this.flags = { ...this.flags, ...flags }
        console.log(base, newFlags)

        let newRate = nymphRate * (double ? 2 : 1)
        const result: IActionResult = {
            damage: 0,
            shield: 0,
            heal: 0,
            taunted: false,
            special,
            double,
            flags: { ...newFlags },
            disabled: {},
        }
        const ret = { attack, attackAll, guard, heal }
        if (oldFlags["nymphAttackDisabled"]) {
            if (ret.attack) result.disabled.attack = true
            ret.attack = 0
            result.flags["nymphAttackDisabled"] = false
        }
        if (oldFlags["nymphHealGuardDisabled"]) {
            if (ret.guard) result.disabled.guard = true
            if (ret.heal) result.disabled.heal = true
            ret.guard = 0
            ret.heal = 0
            result.flags["nymphHealGuardDisabled"] = false
        }
        ret.attack = ret.attack * newRate
        ret.attackAll = ret.attackAll * newRate
        ret.guard = ret.guard * newRate
        ret.heal = ret.heal * newRate

        if (oldFlags["kaltsTaunt"]) {
            if (ret.attack || buff) {
                result.taunted = true
            }
            result.damage = Math.ceil(ret.attackAll)
        } else {
            result.damage = Math.ceil(ret.attack + ret.attackAll)
            if (buff) {
                result.buff = true
            }
        }
        result.flags["kaltsTaunt"] = false
        result.heal = Math.ceil(ret.heal)
        result.shield = Math.ceil(ret.guard)

        const { health: newKaltsHealth, shield: newKaltsShield } =
            calcDamageHealth(kaltsHealth, kaltsShield, result.damage)

        const { health: newNymphHealth, shield: newNymphShield } =
            calcHealHealth(nymphHealth, nymphShield, result.heal, result.shield)

        set((state) => {
            const ret: Partial<IGameBattleStore> = {
                flags: { ...state.flags, ...result.flags },
                kaltsHealth: newKaltsHealth,
                kaltsShield: newKaltsShield,
                nymphHealth: newNymphHealth,
                nymphShield: newNymphShield,
                nymphRate: newRate,
            }
            if (result.buff) {
                ret.kaltsDebuff = state.kaltsDebuff + 1
            }
            if (!base.again) {
                // 当前道具不是重复上回合效果时记录当前回合效果
                ret.lastBase = base
            }
            return ret
        })
        // console.log("[goNymph]", result)
        return result
    },
    goKalts: (base: IKaltsActionBase) => {
        const { attack, guard, heal, flags: newFlags } = base
        const {
            flags: oldFlags,
            kaltsHealth,
            kaltsShield,
            nymphHealth,
            nymphShield,
        } = get()
        // this.flags = { ...this.flags, ...flags }
        const ret = { attack, guard, heal }
        const result: IActionResult = {
            damage: 0,
            shield: 0,
            heal: 0,
            flags: { ...newFlags },
            disabled: {},
        }
        if (oldFlags["kaltsAttackDisabled"]) {
            if (ret.attack) result.disabled.attack = true
            ret.attack = 0
            result.flags["kaltsAttackDisabled"] = false
        }
        if (oldFlags["kaltsHealDisabled"]) {
            if (ret.heal) result.disabled.heal = true
            ret.heal = 0
            result.flags["kaltsHealDisabled"] = false
        }
        result.flags.kaltsTaunt = base.flags?.["kaltsTaunt"]
        result.damage = ret.attack
        result.heal = ret.heal
        result.shield = ret.guard

        const { health: newKaltsHealth, shield: newKaltsShield } =
            calcHealHealth(kaltsHealth, kaltsShield, result.heal, result.shield)

        const { health: newNymphHealth, shield: newNymphShield } =
            calcDamageHealth(nymphHealth, nymphShield, result.damage)

        set((state) => {
            const ret: Partial<IGameBattleStore> = {
                flags: { ...state.flags, ...result.flags },
                kaltsHealth: newKaltsHealth,
                kaltsShield: newKaltsShield,
                nymphHealth: newNymphHealth,
                nymphShield: newNymphShield,
            }
            return ret
        })
        return result
    },

    checkKaltsBuff: () => {
        const { kaltsDebuff, nymphRate, kaltsHealth, kaltsShield } = get()
        const damage = kaltsDebuff * BUFF_BASE_DAMAGE * nymphRate
        const { health, shield } = calcDamageHealth(
            kaltsHealth,
            kaltsShield,
            damage
        )
        set({
            kaltsHealth: health,
            kaltsShield: shield,
        })
        return damage
    },
    restart: () => {
        set({
            flags: {
                nymphAttackDisabled: false,
                nymphHealGuardDisabled: false,
                kaltsAttackDisabled: false,
                kaltsHealDisabled: false,
                kaltsTaunt: false,
            },
            kaltsDebuff: 0,
            nymphRate: 1,
            kaltsHealth: 10,
            kaltsShield: 0,
            nymphHealth: 10,
            nymphShield: 0,
        })
    },
}))

export const useGameBattle = () =>
    useGameBattleStore((state) => ({
        flags: state.flags,
        kaltsDebuff: state.kaltsDebuff,
        nymphRate: state.nymphRate,
        kaltsHealth: state.kaltsHealth,
        kaltsShield: state.kaltsShield,
        nymphHealth: state.nymphHealth,
        nymphShield: state.nymphShield,
        goNymph: state.goNymph,
        goKalts: state.goKalts,
        checkKaltsBuff: state.checkKaltsBuff,
    }))
